<template>
        <b-modal :static="true" :title="Core.Definition.getDefinition('Récupération du mot de passe')" v-model="dataShow"  :hide-footer="true">
                <Request
                        ref="requestPasswordRecovery"
                        method="GET"
                        :options="{ blockOnProcessing: false, showAlert: false }"
                        :onRequestSuccess="requestPasswordRecoverySuccess"
                        root="/user/password-recovery">
                    <slot slot="body">
                        <b-form v-on:submit.prevent="onPasswordRecoveryClick">
                            {{Core.Definition.getDefinition('Entrez le courriel associé à votre compte, un lien de récupération sera envoyé par courriel.')}}</p>
                            <b-input-group class="mb-4">
                                <b-input-group-prepend>
                                    <b-input-group-text><i class="fa fa-envelope-o"></i>
                                    </b-input-group-text>
                                </b-input-group-prepend>
                                <b-form-input v-on:keyup.enter="onPasswordRecoveryClick" v-model="dataUser" type="text" class="form-control"
                                              :placeholder="Core.Definition.getDefinition('Courriel')"
                                              autocomplete="username email"/>
                            </b-input-group>
                            <Alert :alert="dataAlert"></Alert>
                            <b-row>
                                <b-col cols="12">
                                    <b-button type="button" :disabled="dataProcessing" :style="{ 'background-color':  Core.Session.Setting.getSetting('environment.ui.login.loginButtonBGColor', '', Core.Value.typeColor) , 'border-color':  Core.Session.Setting.getSetting('environment.ui.login.loginButtonBorderColor', '', Core.Value.typeColor), 'color':  Core.Session.Setting.getSetting('environment.ui.login.loginButtonTextColor', '', Core.Value.typeColor)}" @click="onPasswordRecoveryClick" class="px-4">
                                        <i  v-if="dataProcessing" class="fa fa-spin fa-spinner mr-1"></i>{{Core.Definition.getDefinition('Récupérer')}}
                                    </b-button>
                                </b-col>
                            </b-row>
                        </b-form>
                    </slot>
                </Request>
        </b-modal>
</template>

<script>
    import Request from '../components/Request'
    import Alert from '../components/Alert'
    import CryptoJS from 'crypto-js'
    export default {
        name: 'ModalLogin',
        components: {
            Request,
            Alert
        },
        props: {},
        watch: {},
        mounted() {
        },
        data: () => {
            return {
                Core: window.Core,
                dataShow: false,
                dataUser: '',
                dataProcessing: false,
                dataAlert: {}
            }
        },
        computed: {
            open: {
                set(val) {
                    this.dataShow = val
                },
                get() {
                    return this.dataShow
                }
            }
        },
        methods: {
            onPasswordRecoveryClick(e) {
                e.preventDefault()
                this.dataProcessing = true
                this.$refs.requestPasswordRecovery.addArg('user', this.dataUser)
                this.$refs.requestPasswordRecovery.request()
            },
            requestPasswordRecoverySuccess(data) {
                if (data.alert!==undefined) {
                    this.dataAlert = data.alert
                } else {
                    this.$emit('onPasswordRecoverySuccess', data)
                }
                this.dataProcessing = false
            }
        }
    }
</script>